import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AddMultiplePhoneNumberComponent } from "@onsip/web/features/administrators/phoneNumbers/addPhoneNumberDialog/addMultiplePhoneNumber/add-multiple-phone-number.component";
import { AddSinglePhoneNumberComponent } from "@onsip/web/features/administrators/phoneNumbers/addPhoneNumberDialog/addSinglePhoneNumber/add-single-phone-number.component";
import { AddNumberDialogComponent } from "@onsip/web/features/administrators/phoneNumbers/addPhoneNumberDialog/add-phone-number-dialog.component";
import { ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { FormEventTrackingModule } from "@onsip/web/features/shared/components/analytics/form-event-tracking.module";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { ImageUploaderModule } from "@onsip/web/features/shared/components/imageUploader/image-uploader.module";
import { OnsipFormsModule } from "@onsip/web/features/shared/components/forms/onsip-forms.module";
import { AddressAutocompleteModule } from "@onsip/web/features/administrators/addressAutocomplete/address-autocomplete.module";
import { LoadingContainerComponent } from "@onsip/web/features/shared/components/loadingContainer/loading-container.component";

@NgModule({
  declarations: [
    AddNumberDialogComponent,
    AddSinglePhoneNumberComponent,
    AddMultiplePhoneNumberComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    FormEventTrackingModule,
    TranslateModule,
    PipesModule,
    ImageUploaderModule,
    OnsipFormsModule,
    AddressAutocompleteModule,
    LoadingContainerComponent
  ]
})
export class AddPhoneNumberDialogModule {}
